import { Country } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<Country>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const countriesReducer = createReducer<State, Actions>(initialState, {
  [actions.getCountries.request.type]: actionsHandlers.handleGetManyRequest,
  [actions.getCountries.success.type]: actionsHandlers.handleGetManySuccess,
  [actions.getCountries.failure.type]: actionsHandlers.handleGetManyFailure,
  [actions.getCountries.reset.type]: actionsHandlers.handleGetManyReset,
});

export default countriesReducer;
